var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobListEmptyIllustration2026(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 240,
    viewBox: "13.1 2.2 224 240.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration=real-time-data"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip_job_list_empty_2026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M188.65 88.8999C190.95 89.9999 213.75 101 220.45 119.9C226.55 137.1 214.65 147.2 212.85 148.6",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M235.35 98.8L230.85 103.3",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M230.85 98L236.45 103.6",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.65 99.7998C31.15 100.2 30.15 101 28.95 102.1",
    stroke: "#5B5BA8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.25 107C19.55 112.5 14.45 120.7 13.65 131C13.35 135.2 13.85 139 14.65 142.1",
    stroke: "#5B5BA8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.88 6.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.6499 145.3C16.0499 146.5 16.5499 147.6 17.0499 148.5",
    stroke: "#5B5BA8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.1499 111.3L35.6499 115.9",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.6499 110.6L41.2499 116.2",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.1,
    d: "M157.55 182.5C134.15 168.9 96.15 168.9 72.55 182.5C49.05 196.1 48.85 218.1 72.25 231.7C95.65 245.3 133.65 245.3 157.25 231.7C180.75 218.2 180.95 196.1 157.55 182.5Z",
    fill: "#57009A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M174.05 196.5C174.05 196.2 174.05 195.9 174.15 195.6C174.15 195.4 174.15 195.2 174.15 195C174.15 194.9 174.15 194.7 174.15 194.6V184.8C174.15 185.1 174.15 185.5 174.15 185.8C174.15 186.1 174.15 186.4 174.05 186.7C174.05 187 173.95 187.2 173.95 187.5C173.95 187.8 173.85 188.1 173.85 188.4C173.85 188.7 173.75 188.9 173.65 189.2C173.55 189.5 173.55 189.8 173.45 190.1C173.35 190.4 173.25 190.6 173.25 190.9C173.15 191.2 173.05 191.5 172.95 191.8C172.85 192.1 172.75 192.3 172.65 192.6C172.55 192.9 172.45 193.2 172.25 193.5C172.15 193.8 172.05 194 171.85 194.3C171.75 194.6 171.55 194.9 171.45 195.2C171.35 195.4 171.15 195.7 171.05 195.9C170.85 196.2 170.65 196.6 170.45 196.9C170.35 197.1 170.15 197.4 169.95 197.6C169.75 197.9 169.45 198.3 169.25 198.6C169.05 198.9 168.85 199.2 168.65 199.4C168.55 199.5 168.45 199.6 168.35 199.7C167.95 200.2 167.65 200.6 167.15 201C167.05 201.1 167.05 201.1 166.95 201.2C166.55 201.6 166.25 202 165.85 202.4C165.75 202.5 165.65 202.6 165.55 202.7C165.25 203 164.95 203.3 164.65 203.5C164.45 203.7 164.15 203.9 163.95 204.2C163.65 204.5 163.35 204.7 162.95 205C162.65 205.2 162.45 205.4 162.15 205.6C161.85 205.9 161.45 206.1 161.05 206.4C160.75 206.6 160.55 206.8 160.25 207C159.85 207.3 159.45 207.5 159.05 207.8C158.75 208 158.55 208.1 158.25 208.3C157.55 208.7 156.85 209.2 156.15 209.6C155.25 210.1 154.25 210.7 153.25 211.1C152.95 211.2 152.75 211.4 152.45 211.5C151.65 211.9 150.75 212.3 149.95 212.7C149.75 212.8 149.55 212.9 149.35 213C148.35 213.4 147.25 213.9 146.25 214.2C145.95 214.3 145.75 214.4 145.45 214.5C144.55 214.8 143.75 215.1 142.85 215.4C142.55 215.5 142.25 215.6 141.95 215.7C141.55 215.8 141.05 216 140.65 216.1C140.25 216.2 139.75 216.4 139.35 216.5C138.95 216.6 138.45 216.7 138.05 216.8C137.65 216.9 137.15 217 136.65 217.1C136.25 217.2 135.75 217.3 135.35 217.4C134.85 217.5 134.45 217.6 133.95 217.7C133.45 217.8 133.05 217.9 132.55 218C132.15 218.1 131.65 218.2 131.25 218.2C130.15 218.4 129.05 218.6 127.85 218.7H127.75C126.65 218.9 125.55 219 124.45 219.1C124.05 219.1 123.65 219.2 123.25 219.2C122.65 219.3 121.95 219.3 121.35 219.4C120.95 219.4 120.55 219.5 120.15 219.5C119.55 219.5 118.85 219.6 118.25 219.6C117.85 219.6 117.45 219.6 116.95 219.7C116.45 219.7 115.85 219.7 115.35 219.7C114.95 219.7 114.45 219.7 114.05 219.7C113.45 219.7 112.95 219.7 112.35 219.7C111.95 219.7 111.45 219.7 111.05 219.7C110.55 219.7 110.05 219.7 109.55 219.6C109.05 219.6 108.65 219.6 108.15 219.5C107.65 219.5 107.15 219.4 106.65 219.4C106.15 219.4 105.75 219.3 105.25 219.3C104.75 219.3 104.25 219.2 103.75 219.2C103.25 219.2 102.85 219.1 102.35 219.1C101.85 219 101.35 219 100.85 218.9C100.45 218.8 99.95 218.8 99.55 218.7C98.95 218.6 98.35 218.5 97.65 218.4C97.35 218.3 96.95 218.3 96.65 218.2C95.85 218.1 95.15 217.9 94.45 217.8C94.25 217.8 94.05 217.7 93.85 217.7C92.85 217.5 91.85 217.3 90.85 217C90.55 216.9 90.25 216.8 89.95 216.8C89.25 216.6 88.55 216.5 87.95 216.3C87.65 216.2 87.35 216.1 87.05 216C86.15 215.7 85.25 215.5 84.45 215.2C84.15 215.1 83.85 215 83.65 214.9C82.55 214.5 81.55 214.2 80.45 213.8C79.95 213.6 79.55 213.4 79.15 213.3C78.85 213.2 78.45 213 78.15 212.9C77.65 212.7 77.25 212.5 76.75 212.3C76.45 212.2 76.15 212 75.75 211.9C75.25 211.7 74.75 211.4 74.25 211.1C73.95 211 73.75 210.8 73.45 210.7C72.75 210.3 71.95 209.9 71.25 209.5C59.65 202.7 53.85 193.9 53.75 185.1V194.9C53.75 203.7 59.55 212.6 71.25 219.3C71.95 219.7 72.75 220.1 73.45 220.5C73.75 220.6 73.95 220.8 74.25 220.9C74.75 221.2 75.25 221.4 75.75 221.7C76.05 221.8 76.35 222 76.65 222.1C77.15 222.3 77.55 222.5 78.05 222.7C78.35 222.8 78.75 223 79.05 223.1C79.45 223.3 79.85 223.4 80.25 223.6H80.35C81.35 224 82.45 224.4 83.55 224.7C83.85 224.8 84.05 224.9 84.35 225C85.25 225.3 86.05 225.5 86.95 225.8C87.15 225.9 87.35 225.9 87.45 226C87.55 226 87.65 226.1 87.85 226.1C88.55 226.3 89.15 226.5 89.85 226.6C90.15 226.7 90.45 226.8 90.75 226.8C91.75 227 92.75 227.3 93.75 227.5C93.95 227.5 94.15 227.6 94.35 227.6C95.05 227.7 95.85 227.9 96.65 228C96.95 228.1 97.35 228.1 97.75 228.2C98.35 228.3 98.95 228.4 99.55 228.5C99.65 228.5 99.65 228.5 99.75 228.5C100.15 228.6 100.45 228.6 100.85 228.6C101.35 228.7 101.85 228.7 102.35 228.8C102.75 228.8 103.25 228.9 103.65 228.9C104.15 228.9 104.65 229 105.15 229C105.25 229 105.35 229 105.45 229C105.85 229 106.15 229 106.55 229.1C107.05 229.1 107.55 229.2 108.05 229.2C108.55 229.2 108.95 229.2 109.45 229.3C109.95 229.3 110.45 229.3 110.95 229.4C111.05 229.4 111.15 229.4 111.25 229.4C111.55 229.4 111.95 229.4 112.25 229.4C112.75 229.4 113.35 229.4 113.85 229.4C114.25 229.4 114.75 229.4 115.15 229.4C115.65 229.4 116.25 229.4 116.75 229.4C116.95 229.4 117.05 229.4 117.25 229.4C117.55 229.4 117.75 229.4 118.05 229.4C118.65 229.4 119.35 229.3 119.95 229.3C120.35 229.3 120.75 229.2 121.15 229.2C121.75 229.2 122.45 229.1 123.05 229C123.35 229 123.55 229 123.85 228.9C123.95 228.9 124.15 228.9 124.25 228.9C125.35 228.8 126.45 228.7 127.55 228.5H127.65C128.75 228.3 129.85 228.2 131.05 228C131.15 228 131.25 228 131.45 227.9C131.75 227.8 132.05 227.8 132.35 227.7C132.85 227.6 133.25 227.5 133.75 227.4C134.25 227.3 134.65 227.2 135.15 227.1C135.65 227 136.05 226.9 136.55 226.8C137.05 226.7 137.45 226.6 137.95 226.5C138.35 226.4 138.85 226.3 139.25 226.2C139.65 226.1 140.15 225.9 140.55 225.8C140.95 225.7 141.45 225.5 141.85 225.4C141.95 225.4 142.15 225.3 142.25 225.3C142.45 225.2 142.55 225.2 142.75 225.1C143.65 224.8 144.45 224.5 145.35 224.2C145.65 224.1 145.85 224 146.15 223.9C147.25 223.5 148.25 223.1 149.25 222.7C149.45 222.6 149.65 222.5 149.85 222.4C150.75 222 151.55 221.6 152.35 221.2C152.65 221.1 152.85 220.9 153.15 220.8C154.15 220.3 155.05 219.8 156.05 219.3C156.75 218.9 157.45 218.5 158.05 218.1C158.05 218.1 158.05 218.1 158.15 218.1C158.45 217.9 158.65 217.8 158.95 217.6C159.35 217.3 159.75 217.1 160.15 216.8C160.45 216.6 160.65 216.4 160.95 216.2C161.35 215.9 161.65 215.7 162.05 215.4C162.35 215.2 162.55 215 162.85 214.8C163.15 214.5 163.45 214.3 163.85 214C164.05 213.8 164.35 213.6 164.55 213.3C164.75 213.1 165.05 212.9 165.25 212.7C165.35 212.6 165.35 212.6 165.45 212.5C165.55 212.4 165.65 212.3 165.75 212.2C166.15 211.8 166.55 211.4 166.85 211C166.95 210.9 166.95 210.9 167.05 210.8C167.45 210.4 167.85 209.9 168.25 209.5C168.35 209.4 168.45 209.3 168.55 209.2C168.65 209.1 168.75 208.9 168.85 208.8C168.95 208.7 169.05 208.5 169.15 208.4C169.35 208.1 169.65 207.7 169.85 207.4C170.05 207.2 170.15 206.9 170.35 206.7C170.55 206.4 170.75 206 170.95 205.7C171.05 205.6 171.15 205.4 171.25 205.3C171.35 205.2 171.35 205.1 171.35 205C171.55 204.7 171.65 204.4 171.75 204.1C171.85 203.8 172.05 203.6 172.15 203.3C172.25 203 172.35 202.7 172.55 202.4C172.65 202.2 172.75 202 172.75 201.9C172.75 201.8 172.85 201.7 172.85 201.6C172.95 201.3 173.05 201 173.15 200.7C173.25 200.4 173.35 200.2 173.35 199.9C173.45 199.6 173.45 199.3 173.55 199C173.55 198.8 173.65 198.6 173.65 198.4C173.65 198.3 173.65 198.2 173.65 198.2C173.75 197.9 173.75 197.6 173.75 197.3C173.95 197 173.95 196.7 174.05 196.5Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M71.6501 160.4C95.1501 146.8 133.25 146.8 156.65 160.4C180.05 174 179.95 196 156.35 209.6C132.85 223.2 94.7501 223.2 71.3501 209.6C47.9501 196.1 48.1501 174 71.6501 160.4Z",
    fill: "#E6E7FF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M107.15 182.3C107.15 182.3 112.15 179.2 112.95 178.9C113.75 178.7 121.05 175.4 128.75 177.5C136.45 179.6 139.05 183.3 138.65 186.7C138.25 190.1 133.75 192.5 133.35 192.8C132.95 193.1 124.95 197.6 124.95 197.6",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M120.85 187.1C120.85 187.1 115.85 190.2 115.05 190.5C114.25 190.7 106.95 194 99.2499 191.9C91.5499 189.8 88.9499 186.1 89.3499 182.7C89.7499 179.3 94.2499 176.9 94.6499 176.6C95.0499 176.3 103.05 171.8 103.05 171.8",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M111.55 172.9C111.55 172.9 98.55 180.5 98.25 180.9C97.85 181.4 95.65 183.8 98.45 186.1C101.75 188.8 108.45 188.2 112.65 185.4C116.75 182.5 124.85 178.8 130.05 184C133.35 187.3 125.75 190.9 125.75 190.9L115.25 197.1",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M118.35 172.9C116.55 173.9 113.55 174 111.75 172.9C109.95 171.8 109.95 170.1 111.75 169.1C113.55 168 116.55 168 118.35 169.1C120.15 170.1 120.15 171.8 118.35 172.9Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M115.05 200.8C113.25 201.8 110.25 201.9 108.45 200.8C106.65 199.7 106.65 198 108.45 197C110.25 195.9 113.25 195.9 115.05 197C116.85 198 116.85 199.7 115.05 200.8Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M105.25 73.7999L74.0501 91.7999C70.8501 93.5999 68.3501 98.0999 68.3501 101.7L68.4501 108.2L68.6501 122.5L69.5501 184.6L164.95 129.5L165.15 58.7999C165.15 55.2999 162.55 53.8999 159.45 55.6999L111.15 83.5999L111.05 76.8999C110.95 73.3999 108.45 71.9999 105.25 73.7999Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M167.55 80.2999L85.35 123.8C81.75 125.5 78.35 129.4 77.85 132.6L69.75 184.4L164.95 129.5L173.25 82.8999C173.75 79.7999 171.15 78.5999 167.55 80.2999Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M146.05 99.7999L144.35 109.2L165.05 97.4999L166.65 88.0999L146.05 99.7999Z",
    fill: "#7A2EFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M45.5499 101.1L37.6499 96.4998V87.2998L45.5499 91.8998V101.1Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M45.5499 91.8998L37.6499 87.2999L45.6499 82.5999L53.5499 87.2999L45.5499 91.8998Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M53.5498 87.2998V96.3998L45.5498 101.1V91.8998L53.5498 87.2998Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M200.35 165.2L192.45 160.6L192.35 151.4L200.35 156V165.2Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M200.35 156L192.35 151.4L200.35 146.8L208.35 151.4L200.35 156Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M208.35 151.4V160.6L200.35 165.2V156L208.35 151.4Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M96.05 91.1C100.35 60.9 115.45 48.5999 129.25 43.2999C131.15 42.5999 135.35 40.9 138.25 42.9C141.25 45 142.05 50.3 140.05 53.4C137.35 57.4 129.95 57.4 125.95 55.2C118.15 50.9 109.85 33.2 136.45 16.7",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M142.95 11L144.55 19.7L146.35 13.8L171.25 2.69995L142.95 11Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M144.55 19.7L171.25 2.69995L146.35 13.8L144.55 19.7Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M171.25 2.69995L154.05 21.7L146.35 13.8L171.25 2.69995Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M139.45 7.09995L142.95 11L171.25 2.69995L139.45 7.09995Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_job_list_empty_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223.9,
    height: 239.8,
    fill: "white",
    transform: "translate(13.05 2.19995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobListEmptyIllustration2026);
export default __webpack_public_path__ + "static/media/job-list-empty-illustration-2026.1c01a30c7ca9073042b6fda93f1ae092.svg";
export { ForwardRef as ReactComponent };